export default __webpack_public_path__ + "static/media/refreshIcon.c34bbb36.svg";